import React from "react";
import { colors } from '../../../theme/colors';
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GuidelinesDialog } from "../../../pages/app/technical-assessment/style";

const GUIDELINES = [
  "This is a timed coding assessment. You have 60 minutes to complete all 6 questions.",
  "Your webcam must remain on throughout the test for identity verification.",
  "Do not switch tabs or leave fullscreen mode. Violations may result in automatic test cancellation after 3 warnings.",
  "Copy, paste, and cut operations are disabled in the code editor for integrity purposes.",
  "Use the 'Save' button to save progress on each question before moving to the next.",
  "You can navigate between questions using the sidebar or Previous/Next buttons.",
  "Once you submit the test, you cannot modify your answers.",
  "Ensure you have a stable internet connection throughout the assessment.",
  "The test includes questions of varying difficulty: Medium and Hard.",
  "Your code will be evaluated for correctness, efficiency, and code quality.",
];

const GuidelinesDialogBox = ({ open, onClose }) => {
  return (
    <GuidelinesDialog open={open} onClose={onClose}>
      <Box className="guidelines-header">
        <Typography sx={{ fontSize: "18px", fontWeight: 700 }}>
          Assessment Guidelines
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "#fff" }} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className="guidelines-body">
        <ol>
          {GUIDELINES.map((rule, idx) => (
            <li key={idx}>{rule}</li>
          ))}
        </ol>
      </Box>
      <Box className="guidelines-footer">
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: colors.primary,
            borderRadius: "10px",
            textTransform: "none",
            px: 4,
            "&:hover": { backgroundColor: colors.primaryHover },
          }}
        >
          I Understand
        </Button>
      </Box>
    </GuidelinesDialog>
  );
};

export default GuidelinesDialogBox;
